export default 'reservationsPage';
